// extracted by mini-css-extract-plugin
export default {"group-option":"cyvy1MAa"};